import { Location } from "@skinsoft/types";
import { SEARCH_TYPES } from "@skinsoft/const";

import { LocationDataStore } from "@skinsoft/entity";
import { CACHE_KEYS, LocationOfflineDataFetcher } from "@skinsoft/offline";
import { EntitySyncDownHandler } from "../../entity-sync-down-handler";

declare const config
const SEARCH_PAGE_SIZE = config.syncDownPageSize.location ?? config.syncDownPageSize.default

export class LocationSyncDownHandler extends EntitySyncDownHandler<Location, Location, Location> {
    private static instance: LocationSyncDownHandler = null as any

    public static getInstance() {
        if (!LocationSyncDownHandler.instance) {
            LocationSyncDownHandler.instance = new LocationSyncDownHandler()
        }

        return LocationSyncDownHandler.instance
    }

    public static install(Vue) {
        LocationSyncDownHandler.getInstance()
    }

    constructor() {
        super(
            [SEARCH_TYPES.location],
            LocationDataStore.getInstance(),
            new LocationOfflineDataFetcher(CACHE_KEYS.Location),
            CACHE_KEYS.Location,
            SEARCH_PAGE_SIZE
        )
    }
}